import { Component, OnInit } from '@angular/core';

import { MovieService } from '../services/movie.service';

@Component({
  selector: 'app-add-movie',
  templateUrl: './add-movie.component.html',
  styleUrls: ['./add-movie.component.scss']
})
export class AddMovieComponent implements OnInit {

  public movies = '';

  constructor(private movieServ: MovieService) { }

  ngOnInit(): void {
  }

  async submit() {
    const parseMovies = JSON.parse(this.movies);
    if (parseMovies.length) {
      await this.movieServ.addMovies(parseMovies);
      this.movies = '';
   }
  }

}
